import { type OverrideBookie } from '../types/contract';

/**
 * Maps the rich `overrideBookies` contract shape (`{ code, priority }[]`) down to the plain
 * `string[]` of codes that the shared `@cx-modules/odds-grid-api-service` still expects on the
 * wire. The `priority` is a client-side display concern (see `useBookmakersAll`) and is never
 * sent to the backend. Returns `undefined` when empty/absent so `[]` and `undefined` collapse to
 * the same cache key.
 */
export const overrideBookiesToCodes = (overrideBookies?: OverrideBookie[]): string[] | undefined =>
  overrideBookies?.length ? overrideBookies.map(bookie => bookie.code) : undefined;
